import initialState from "./InitialStates";
import Action from "../actions/Actions";
import update from "immutability-helper";

const TransactionReducer = (state = initialState.transaction, action) => {
    switch (action.type) {
    case Action.TRANSACTION_REQUEST:
        return update(state, {loading: {$set: true}});
    case Action.TRANSACTION_SUCCESS:
        const pagination = { ...state.pagination };
        pagination.total = action.payload.info.results;
        pagination.pageSize = action.pagesize;
        return update(state, {
            loading: {$set: false},
            data: {$set: action.payload.results},
            pagination: {$set: pagination}
        });
    default:
        return state;
    }
};

export default TransactionReducer;